import { j as r } from "../../../jsx-runtime.BREq8dyb.js";
import { memo as m, forwardRef as l } from "react";
import s from "../components/DqCardBase.js";
import d from "../components/DqCardControl.js";
const f = m(l(({
  children: a,
  selectable: o,
  ...e
}, t) => /* @__PURE__ */ r.jsxs(s, { ...e, ref: t, selectable: !0, children: [
  /* @__PURE__ */ r.jsx(d, { selectable: o, ...e }),
  a
] })));
f.displayName = "DqCardSelectable";
export {
  f as default
};
//# sourceMappingURL=DqCardSelectable.js.map
